import PropTypes from 'prop-types';

export const PaxProps = PropTypes.shape({
    adults: PropTypes.number.isRequired,
    kids: PropTypes.number.isRequired,
    infants: PropTypes.number.isRequired,
});

export const PaxPropsDefault = {
    adults: 1,
    kids: 0,
    infants: 0,
};
